export default __webpack_public_path__ + "78a8b7afe205a3605a2bb4b304464b3a.svg";